// components/Banner.jsx
import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function Banner() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [visible, setVisible] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const onAnySidebarToggle = (e) => {
      setSidebarOpen(Boolean(e?.detail?.open));
    };

    window.addEventListener("menu:toggle", onAnySidebarToggle);
    window.addEventListener("search:toggle", onAnySidebarToggle);
    window.addEventListener("cart:toggle", onAnySidebarToggle);
    window.addEventListener("wishlist:toggle", onAnySidebarToggle);
    window.addEventListener("signup:toggle", onAnySidebarToggle);

    return () => {
      window.removeEventListener("menu:toggle", onAnySidebarToggle);
      window.removeEventListener("search:toggle", onAnySidebarToggle);
      window.removeEventListener("cart:toggle", onAnySidebarToggle);
      window.removeEventListener("wishlist:toggle", onAnySidebarToggle);
      window.removeEventListener("signup:toggle", onAnySidebarToggle);
    };
  }, []);

  useEffect(() => {
    const effectiveVisible = visible && isHomePage;
    window.__nufabBannerVisible = effectiveVisible;
    window.dispatchEvent(new CustomEvent('banner:visibility', { detail: { visible: effectiveVisible } }));

    // Keep a single source of truth for navbar offset.
    document.documentElement.style.setProperty('--nufab-banner-height', effectiveVisible ? '40px' : '0px');
  }, [visible, isHomePage]);

  if (!visible) return null;

  return (
    <div
      id="site-banner"
      className={`relative top-0 left-0 w-full bg-black text-white
                 px-4 py-2 h-10 flex items-center justify-center text-xs lg:text-sm overflow-hidden`}
      style={{ zIndex: sidebarOpen ? 0 : 100, pointerEvents: sidebarOpen ? "none" : "auto" }}
    >
      {/* Mobile - Scrolling text */}
      <div className="lg:hidden md:hidden w-full overflow-hidden pl-2 pr-10">
        <div className="flex animate-marquee whitespace-nowrap">
          <span className="mx-4">
            Worldwide Shipping & 24*7 Returns available | With love from Nufab team
          </span>
          <span className="mx-4">
            Worldwide Shipping & 24*7 Returns available | With love from Nufab team
          </span>
        </div>
      </div>

      {/* Large screen - Static text */}
      <span className="hidden lg:block md:block whitespace-nowrap">
        Worldwide Shipping & 24*7 Returns available | With love from Nufab team
      </span>

      <button
        onClick={() => setVisible(false)}
        aria-label="close banner"
        className="absolute right-2 lg:right-4 top-1/2 -translate-y-1/2 p-2 rounded-full focus:outline-none bg-black z-10"
      >
        <X size={16} />
      </button>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 15s linear infinite;
        }
      `}</style>
    </div>
  );
}
